import React, { useState, useEffect } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { NavLink } from 'react-router-dom';

// Import assets
import Gdmorning from '@assets/images/Gdmorning.svg';
import Catrina from '@assets/images/Catrina.svg';
import earthquake from '@assets/images/earthquake.jpeg';
import earthquakeVenezuela from '@assets/images/earth_quake_venezuela_item.jpg';

// Import constants
import { heroSlides } from '@/constants';

// Import Swiper styles
import 'swiper/css';

export function Home() {
  const [showText, setShowText] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    setTimeout(() => setShowText(true), 8000);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderSlideContent = (slide) => {
    const LinkWrapper = slide.linkType === 'internal' ? NavLink : 'a';
    const linkProps = slide.linkType === 'internal'
      ? { to: slide.to }
      : { href: slide.href, target: '_blank', rel: 'noreferrer' };

    return (
      <div id={slide.id}>
        <div className='hero-title-group'>
          <LinkWrapper {...linkProps}>
            <h1 className='hero-title'>
              <div className='beta-text-label'>BETA</div>
              {isMobile ? (
                <div className='text-wrap'>
                  <span>{slide.mobileTextWrap}</span>
                  <img className='arrow-right' src={slide.arrowImage} alt='arrow' />
                </div>
              ) : (
                <>
                  {slide.titleLines.map((line, index) => (
                    <span key={index}>{line}</span>
                  ))}
                  <div className='text-wrap'>
                    <span>{slide.textWrap}</span>
                    <img className='arrow-right' src={slide.arrowImage} alt='arrow' />
                  </div>
                </>
              )}
            </h1>
            {slide.infoParagraph && (
              <p
                className='hero-title-info'
                dangerouslySetInnerHTML={{
                  __html: isMobile && slide.mobileInfoParagraph
                    ? slide.mobileInfoParagraph
                    : slide.infoParagraph
                }}
              />
            )}
          </LinkWrapper>
        </div>
        {slide.bannerImage && (
          <img src={slide.bannerImage} alt={slide.bannerAlt} className='banner-img' />
        )}
        {slide.scrollDownVisible && (showText || !slide.scrollDownHidden) && (
          <Link to='#fund' smooth>
            <div className={`more-content-wrapper ${slide.scrollDownHidden ? 'more-content-wrapper-hidden' : ''}`}>
              <img className='arrow-down' src={slide.arrowDownImage} alt='arrow' />
              <span className={`more-text ${slide.whiteText ? 'white-text' : ''}`}>
                Scroll down for more
              </span>
            </div>
          </Link>
        )}
      </div>
    );
  };

  return (
    <section id='home'>
      <Swiper
        className='mySwiper'
        loop={true}
        speed={700}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
      >
        {heroSlides.filter((slide) => !slide.hidden).map((slide) => (
          <SwiperSlide key={slide.id}>
            {renderSlideContent(slide)}
          </SwiperSlide>
        ))}
      </Swiper>
      <div id='fund'>
        <h1 className='fund-title'>Campaigns</h1>
        <div className='venezuela-collection'>
          <div className='nft-collection'>
            <img
              src={earthquakeVenezuela}
              alt='earthquake venezuela'
              className='nft-collection__img'
            />
            <div className='nft-collection__info-wrapper'>
              <div className='nft-collection__info-top'>
                <h1 className='nft-collection__title venezuela-title'>
                  Venezuela Earthquake Collection
                </h1>
                <p className='nft-collection__desc'>
                  The Venezuela Earthquake Relief campaign supports families devastated by the twin earthquakes of June 24, 2026. Every donation goes directly toward rescue efforts, emergency relief, and rebuilding lives.
                </p>
              </div>
              <div className='nft-collection__info-bottom'>
                <a
                  href='https://venezuelaearthquake.fundraisin.app'
                  target='_blank'
                  rel='noreferrer'
                >
                  <div className='nft-collection__btn venezuela-btn'>
                    Find out more
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='earthquake-collection'>
          <div className='nft-collection'>
            <img
              src={earthquake}
              alt='earthquake'
              className='nft-collection__img'
            />

            <div className='nft-collection__info-wrapper'>
              <div className='nft-collection__info-top'>
                <h1 className='nft-collection__title earthquake-title'>
                  Earthquake Relief Fund in Turkiye
                </h1>
                <p className='nft-collection__desc'>
                  MUAFNFT, a curatorial contemporary art project on Avalanche,
                  is starting an aid campaign for the victims of the earthquake
                  in Turkey through the artist Can Köylüoğlu and Fund Raisin.
                </p>
              </div>
              <div className='nft-collection__info-bottom'>
                <a
                  href={import.meta.env.VITE_MARKETPLACE_EARTHQUAKE_LINK}
                  target='_blank'
                  rel='noreferrer'
                >
                  <div className='nft-collection__btn earthquake-btn'>
                    Find out more
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='nft-collection'>
          <img src={Gdmorning} alt='octopi' className='nft-collection__img' />

          <div className='nft-collection__info-wrapper'>
            <div className='nft-collection__info-top'>
              <h1 className='nft-collection__title octopi-title'>
                The Octopi Collection
              </h1>
              <p className='nft-collection__desc'>
                Discover, collect, and trade extraordinary octopus NFT art while
                saving the oceans with red·dev's fundraiser for{' '}
                <strong>The Ocean Conservancy</strong>.
              </p>
            </div>
            <div className='nft-collection__info-bottom'>
              <a
                href={import.meta.env.VITE_MARKETPLACE_OCTOPI_LINK}
                target='_blank'
                rel='noreferrer'
              >
                <div className='nft-collection__btn octopi-btn'>
                  Seems Rare?
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className='catdrop-collection'>
          <div className='nft-collection'>
            <img
              src={Catrina}
              alt='catdrop'
              className='nft-collection__img catdrop-img'
            ></img>

            <div className='nft-collection__info-wrapper'>
              <div className='nft-collection__info-top'>
                <h1 className='nft-collection__title catdrop-title'>
                  The Catdrops Collection
                </h1>
                <p className='nft-collection__desc'>
                  Discover, collect, and trade extraordinary catdrop NFTs while
                  protecting animals with <strong>FUNPROBIANI</strong>.
                </p>
              </div>
              <div className='nft-collection__info-bottom'>
                <a
                  href={import.meta.env.VITE_MARKETPLACE_CATDROPS_LINK}
                  target='_blank'
                  rel='noreferrer'
                >
                  <div className='nft-collection__btn catdrop-btn'>
                    Seems Rare?
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
